import { MeetingProvider } from "@videosdk.live/react-sdk";
import { useEffect } from "react";
import { useState } from "react";
import { MeetingContainer } from "./meeting/MeetingContainer";
import { LeaveScreen } from "./components/screens/LeaveScreen";
import { JoiningScreen } from "./components/screens/JoiningScreen"
import { useMentorAuth } from "./hooks/MentorAuthContext";

function MentorApp() {
  const { user, getTokenAndFetchUserProfile } = useMentorAuth();
  const [token, setToken] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [micOn, setMicOn] = useState(false);
  const [customAudioStream, setCustomAudioStream] = useState(null);
  const [isMeetingStarted, setMeetingStarted] = useState(false);
  const [isMeetingLeft, setIsMeetingLeft] = useState(false);

  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
  }, [isMobile]);

  useEffect(() => {
    console.log("Mentor user:", user);
    if (!user) {
      getTokenAndFetchUserProfile();
    } else {
      const name = user?.mentorId || user?.name || user?.email || "Mentor";
      console.log("Setting participant name to:", name);
      setParticipantName(name);
    }
  }, [user]);

  return (
    <>
      {isMeetingStarted ? (

        <MeetingProvider
          config={{
            meetingId,
            micEnabled: micOn,
            webcamEnabled: false,
            name: participantName ? participantName : "TestUser",
            multiStream: true,
            customMicrophoneAudioTrack: customAudioStream
          }}
          token={token}
          reinitialiseMeetingOnConfigChange={true}
          joinWithoutUserInteraction={true}
        >
          <MeetingContainer
            onMeetingLeave={() => {
              setToken("");
              setMeetingId("");
              setParticipantName("");
              setMicOn(false);
              setMeetingStarted(false);
            }}
            setIsMeetingLeft={setIsMeetingLeft}
          />
        </MeetingProvider>

      ) : isMeetingLeft ? (
        <LeaveScreen setIsMeetingLeft={setIsMeetingLeft} />
      ) : (

        <JoiningScreen
          participantName={participantName}
          setParticipantName={setParticipantName}
          setMeetingId={setMeetingId}
          setToken={setToken}
          micOn={micOn}
          setMicOn={setMicOn}
          customAudioStream={customAudioStream}
          setCustomAudioStream={setCustomAudioStream}
          onClickStartMeeting={() => {
            setMeetingStarted(true);
          }}
          startMeeting={isMeetingStarted}
          setIsMeetingLeft={setIsMeetingLeft}
        />
      )}
    </>
  );
}

export default MentorApp;
